<template>
  <form v-loading="loading && !model">
    <!-- Header -->
    <div class="tournament-light-blue pa-3">
      <!-- Top -->
      <div class="row">
        <div class="row align-center flex">
          <v-btn class="ma-0" icon @click="$emit('close')">
            <v-icon color="tournament-white">
arrow_back
</v-icon>
          </v-btn>
        </div>
      </div>

      <div v-if="model" class="row flex px-2 mt-3">
        <v-text-field
          v-model="model.name"
          class="big-title tournament-white--text"
          color="tournament-white"
          type="text"
          :disabled="true"
        />
      </div>
    </div>

    <div
      v-loading="!model.event && !model.registration"
      element-loading-text="Carregando dados da equipes"
    >
      <div class="tournament-light-grey py-3 px-4" style="min-height: 180px">
        <!-- Event location -->
        <div
          v-if="model.event && model.event.address"
          class="row align-start mb-4 tournament-light-blue--text"
        >
          <v-icon class="subheading mr-2" color="tournament-light-blue">
            place
          </v-icon>
          <div class="column">
            <div v-if="model.event.location" class="bold">
              {{ model.event.location }}
            </div>
            <div v-if="model.event.address">
              {{ model.event.address.address
              }}{{
                model.event.address.number
                  ? `, ${model.event.address.number}`
                  : ""
              }}{{
                model.event.address.district
                  ? ` - ${model.event.address.district}`
                  : ""
              }}{{
                model.event.address.city ? `, ${model.event.address.city}` : ""
              }}{{
                model.event.address.state
                  ? ` - ${model.event.address.state},`
                  : ""
              }}<br />
              {{
                model.event.address.code
                  ? `${model.event.address.code}, Brasil`
                  : ""
              }}
            </div>
          </div>
        </div>

        <!-- Event Date -->
        <div
          v-if="model.event && model.event.startDate"
          class="row align-start mb-4 tournament-light-blue--text"
        >
          <v-icon class="subheading mr-2" color="tournament-light-blue">
            event
          </v-icon>
          <div class="column">
            {{ eventDate }}
          </div>
        </div>

        <!-- Event Registration Price -->
        <div
          v-if="model.registration && model.registration.fee"
          class="row align-start tournament-light-blue--text"
        >
          <v-icon class="subheading mr-2 bold" color="tournament-light-blue">
            attach_money
          </v-icon>
          <div class="column">
            {{
              model.registration.fee == 0 ? "GRATUITO" : model.registration.fee
            }}
          </div>
        </div>
      </div>

      <!-- Event registration notes -->
      <div
        v-if="model.registration && model.registration.notes"
        class="tournament-white tournament-dark-grey--text px-5 pt-4 pb-5"
        style="min-height: 268px"
      >
        {{ model.registration.notes }}
      </div>
    </div>
  </form>
</template>

<script>
import Event from "@/services/Event";

import FormatDate from "@/helpers/FormatDate";
import _ from "lodash";
export default {
  name: "EventEditor",

  props: {
    cache: {
      type: Object,
    },
    modelId: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      model: {},
    };
  },

  computed: {
    isNew() {
      return !this.modelId;
    },
    eventDate() {
      if (
        _.get(this.model, "event.startDate") &&
        _.get(this.model, "event.endDate")
      ) {
        return (
          FormatDate(
            _.get(this.model, "event.startDate"),
            "DD [de] MMMM [de] YYYY",
            true,
          ) +
          " até " +
          FormatDate(
            _.get(this.model, "event.endDate"),
            "DD [de] MMMM [de] YYYY",
            true,
          )
        );
      } else {
        return FormatDate(_.get(this.model, "event.startDate"), "longerDate");
      }
    },
  },

  created() {
    // Set current model to show model faster (Cache version)
    if (this.cache && this.modelId == this.cache._id) {
      this.model = this.cache;
    }

    // Fetch model events and data
    if (this.modelId) {
      this.fetch();
    }
  },

  methods: {
    fetch() {
      this.loading = true;
      Event.get(this.modelId).then(
        (model) => {
          this.loading = false;
          this.model = model.data;
        },
        () => {
          this.loading = false;
          this.$notify.error({
            title: "Erro",
            message: "Não foi possível abrir as informações desse evento",
          });
          this.$emit("close");
        },
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Events/Editor/index.vue